
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { ContactsUiClient, Contact } from '../../backend/backendapi';
import SelectModal from '../../selectmodal/selectmodal.controller';
import ContactEditModal from './ContactEditModal';
import { emptyUUID } from '../../../util';
import { handleError, initClient } from '../../../api';

@Component({
  components: {
    ContactEditModal,
    SelectModal: require('../../selectmodal/selectmodal.vue.html').default,
  },
})
export default class ContactSelectModal extends Vue {
  @Prop({ required: true })
  readonly allContacts!: Contact[];

  private selectedContacts: Contact[] = [];

  private readonly api = initClient(ContactsUiClient);

  get availableSalutations(): string[] {
    return [...new Set(this.allContacts.map(e => e.salutation).filter(e => !!e).map(e => e!))];
  }

  public open(): void {
    this.selectedContacts.splice(0);
    (this.$refs.selectModal as SelectModal<Contact>).open();
  }

  public dismiss(): void {
    (this.$refs.selectModal as SelectModal<Contact>).dismiss();
  }

  formatContact(contact: Contact): any {
    return contact.email + ' (' + ((contact.firstName ?? '') + ' ' + (contact.lastName ?? '')).trim() + ')';
  }

  onAddContact(entry: Contact): void {
    this.selectedContacts.push(entry);
  }

  onNewContact(): void {
    (this.$refs.editModal as ContactEditModal<Contact>).open(new Contact({
      id: emptyUUID(),
      createdAt: new Date(),
      createdBy: emptyUUID(),
      updatedAt: new Date(),
      updatedBy: emptyUUID(),
      firstName: '',
      lastName: '',
      salutation: '',
      company: '',
      email: '',
      tel: '',
    }));
  }

  onRemoveContact(entry: Contact): void {
    const index = this.selectedContacts.findIndex(e => e.id === entry.id);
    if (index >= 0) {
      this.selectedContacts.splice(index, 1);
    }
  }

  async onSave(contact: Contact): Promise<void> {
    try {
      const c = await this.api.create(contact);
      this.allContacts.push(c);
      this.$toasted.info(this.$t('txtSaved').toString());
      (this.$refs.editModal as ContactEditModal<Contact>).dismiss();
    } catch (e) {
      handleError(this.$toasted, this.$i18n, e);
    }
  }
}
